/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".user-settings p{margin-bottom:10px}.district-multiselect{width:25%;display:inline-block;margin-right:50px}.county-multiselect{width:25%;display:inline-block}.county-district-multiselects,.default-extent,.zoom-to-layer-after-filtering{margin-bottom:50px}.setting{margin-bottom:1em;padding-bottom:1em;border-bottom:1px solid gray}.btn-bar>.btn{margin-right:1em}.btn-bar>.btn:last-child{margin-right:0}.btn-bar>.btn[hidden]{display:none}"];
export { styles as styles };
